module.exports = __webpack_public_path__ + "fonts/iconfont.21053d9a.ttf";